import { AxiosError } from "axios";
import qs from "query-string";
import { useQuery } from "react-query";
import { DocStructuringResponse } from "../types";
import axiosClient from "../utils/axiosClient";

export const useGetDocStructurings = (
  pageTable: number,
  resultsPerPage: number = 20,
  searchTerm?: string,
  usernameSearch?: string
) => {
  const newSkip = (pageTable - 1) * resultsPerPage;
  return useQuery<any, AxiosError<any>, DocStructuringResponse>(
    ["docStructurings", "all", pageTable],
    async () => {
      const query: Record<string, any> = {
        skip: newSkip,
        limit: resultsPerPage,
        searchTerm,
        usernameSearch,
      };
      if (!searchTerm) {
        delete query.searchTerm;
      }
      if (!usernameSearch) {
        delete query.usernameSearch;
      }

      const data = await axiosClient.get<DocStructuringResponse>(
        `/qna/docstructuring/getAll?${qs.stringify(query)}`
      );
      return data.data;
    },
    {
      staleTime: Infinity,
      // Keep the query enabled so react-query's refetchInterval polling fires
      // (it is gated by `enabled` in react-query v3). The component still drives
      // explicit refetches for search/pagination.
      enabled: true,
      // Auto-poll while any job on this page is still running so the progress
      // bar updates without a manual reload. Stops once everything is done.
      refetchInterval: (data) => {
        const hasActive = data?.data?.some(
          (d) => d.status === 'queued' || d.status === 'processing'
        );
        return hasActive ? 5000 : false;
      },
    }
  );
};
